import React,{Suspense} from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
// import "@radix-ui/themes/styles.css";
import { Theme } from "@radix-ui/themes";
import './index.css';
import './index.css';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { AuthProvider } from './context/AuthProvider';



i18n
  .use(initReactI18next) 
  .use(LanguageDetector)
  .use(HttpApi)
  .init({
    supportedLngs:['nl','en'],
    fallbackLng: "nl",
    detection:{
        order: ['path','cookie', 'htmlTag',  'localStorage', 'subdomain'],
        caches:['cookie']

    },
    backend:{
        loadPath: '/assets/locales/{{lng}}/translation.json',

    },
    

   
  });
const loadingMarkup =(
  <div className='py-4 text-center text-white'>Loading...</div>
)
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <Provider store={store}>
  <Suspense fallback={loadingMarkup}>
  <BrowserRouter>
  <Theme>
    <App />
    </Theme>
    </BrowserRouter>
    </Suspense>
    </Provider>
    </AuthProvider>
);








